import classnames from 'classnames/bind'
import Image from '@/components/common/Image'

// Constants
import { EXTERNAL_LINK } from '@/constants/externalLink'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

function SimpleHeader() {
  return (
    <header className={cx('header')}>
      <div className={cx('header__wrapper')}>
        <div className={cx('header-logo')} onClick={() => window.open(EXTERNAL_LINK.XORRO_OFFICIAL_SITE, '_blank')}>
          <Image src={`/images/xorro-logo.png`} width={152} height={45} alt={'Xorro'} />
        </div>

        <div className={cx('header__right')}>
          <button className={cx('header__nav-btn')} onClick={() => window.open(EXTERNAL_LINK.XORRO_OFFICIAL_SITE, '_blank')} aria-label='Home'>
            <Image src='/images/xorro-home-icon.png' width={24} height={24} alt='Home' />
          </button>

          <button className={cx('header__nav-btn')} onClick={() => window.open(EXTERNAL_LINK.XORRO_LINKEDIN, '_blank')} aria-label='LinkedIn'>
            <Image src='/images/hkfec-linkedin-icon.png' width={28} height={28} alt='LinkedIn' />
          </button>
        </div>
      </div>
    </header>
  )
}

export default SimpleHeader
